import { collection, doc, getDoc, getDocs } from 'firebase/firestore';

import { FSCollections } from '@src/constants/database';
import { db } from '@src/firebase/firebase';
import safeExecute from '@src/util/safeExecute';

export class LocationRepository {
  getLocationsByOrgId(orgId: string) {
    return collection(db, FSCollections.ORGANIZATIONS, orgId, FSCollections.LOCATIONS);
  }

  getLocationsByDivisionId(orgId: string, divisionId: string) {
    return collection(
      db,
      FSCollections.ORGANIZATIONS,
      orgId,
      FSCollections.DIVISIONS,
      divisionId,
      FSCollections.LOCATIONS,
    );
  }

  getLocationGroupsByDivisionId(orgId: string, divisionId: string) {
    return collection(
      db,
      FSCollections.ORGANIZATIONS,
      orgId,
      FSCollections.DIVISIONS,
      divisionId,
      FSCollections.LOCATION_GROUPS,
    );
  }

  getCollectionPath(orgId: string, divisionId?: string | null) {
    if (divisionId) {
      return this.getLocationsByDivisionId(orgId, divisionId);
    }
    return this.getLocationsByOrgId(orgId);
  }

  getLocationDocRef(orgId: string, divisionId: string, locationId: string) {
    return doc(
      db,
      FSCollections.ORGANIZATIONS,
      orgId,
      FSCollections.DIVISIONS,
      divisionId,
      FSCollections.LOCATIONS,
      locationId,
    );
  }

  async listFirestore({
    orgId,
    divisionId,
  }: {
    orgId: string;
    divisionId?: string | null;
  }) {
    return safeExecute(async () => {
      const locationsRef = this.getCollectionPath(orgId, divisionId);
      const snapshot = await getDocs(locationsRef);
      return snapshot.docs.map(document => ({
        id: document.id,
        ...document.data(),
      }));
    });
  }

  async getLocationName(
    orgId: string,
    divisionId: string,
    locationId: string,
  ): Promise<string | null> {
    if (!orgId || !divisionId || !locationId) return null;

    const snapshot = await getDoc(this.getLocationDocRef(orgId, divisionId, locationId));
    if (!snapshot.exists()) return null;

    const data = snapshot.data() as { name?: string } | undefined;
    const name = data?.name?.trim();
    return name || null;
  }
}

export default LocationRepository;
